import { render, staticRenderFns } from "./set.vue?vue&type=template&id=6bcf592c&scoped=true"
import script from "./set.vue?vue&type=script&lang=js"
export * from "./set.vue?vue&type=script&lang=js"
import style0 from "./set.vue?vue&type=style&index=0&id=6bcf592c&prod&lang=scss&scoped=true"
import style1 from "./set.vue?vue&type=style&index=1&id=6bcf592c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf592c",
  null
  
)

export default component.exports